import React from 'react';

import { useSelector } from 'react-redux';
import { FiltersDetailsUseStyles } from './FiltersDetailsUseStyles';

const RulerHelper = () => {
  const useString = () => {
    const language = useSelector(state => state.language);
    return language.filters.ruler;
  };
  const subtitles = useString();

  const classes = FiltersDetailsUseStyles();

  return (
    <div className={`${classes.FiltersDetails}__table__details`}>
      <div>{subtitles.start}</div>
      <div>&nbsp;</div>
      <div>
        <strong>{subtitles.mouseButton}</strong>
        {subtitles.stop}
      </div>
    </div>
  );
};

export default RulerHelper;
